// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Creditor } from './creditor';
import { Dividend } from './dividend';
import { Entry } from './entry';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CreditorDividend extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  creditorDividendId!: number;
  admittedTaxTotal!: number;
  admittedTotal!: number;
  centsInDollar!: number;
  createdBy!: string;
  createdDate!: Date;
  creditorId!: number;
  dividendId!: number;
  entryId?: number;
  isEqualised!: boolean;
  spare1!: number;
  spare2!: number;
  statInterest!: number;
  taxPaid!: number;
  totalPaid!: number;
  totalUnclaimed!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  creditor!: Creditor;
  dividend!: Dividend;
  entry!: Entry;
}

